import React from "react";

const ImagePlay = (props) => {
	return (
		<svg
			className="image-play unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<polygon
				className="image-fill-color"
				style={{ fill: props.fillOverride }}
				points="18 11.75 8 17.4757143 8 6"
			></polygon>
		</svg>
	);
};

export default ImagePlay;
